import { makeActionCreator } from '../../config/store/utils'
import { getUserUnitsInfo } from '../../services/config'
import { getRegionCached } from '../../services/config.cached'

export const GET_REGIONS = 'GET_REGIONS'
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS'
export const GET_REGIONS_ERROR = 'GET_REGIONS_ERROR'
export const onGetRegion = makeActionCreator(GET_REGIONS)
export const onGetRegionError = makeActionCreator(GET_REGIONS_ERROR, 'payload')
export const onGetRegionSuccess = makeActionCreator(GET_REGIONS_SUCCESS, 'payload')
export const onGetRegionsThunk = () => async dispatch => {
  dispatch(onGetRegion())

  try {
    const { data } = await getRegionCached()
    const regions_ = data.payload?.map(region => ({ name: region.nombre, value: region.id }))
    const everybodyItem = { name: 'Todos', value: '' }
    const regions = [everybodyItem, ...regions_]

    return dispatch(onGetRegionSuccess({ regions }))
  } catch (error) {
    return dispatch(onGetRegionError(error))
  }
}

export const GET_USER_UNITS = 'GET_USER_UNITS'
export const GET_USER_UNITS_ERROR = 'GET_USER_UNITS_ERROR'
export const GET_USER_UNITS_SUCCESS = 'GET_USER_UNITS_SUCCESS'
export const onGetUserUnits = makeActionCreator(GET_USER_UNITS)
export const onGetUserUnitsError = makeActionCreator(GET_USER_UNITS_ERROR, 'payload')
export const onGetUserUnitsSuccess = makeActionCreator(GET_USER_UNITS_SUCCESS, 'payload')
export const onGetUserUnitsThunk = () => async dispatch => {
  dispatch(onGetUserUnits())

  try {
    const { data } = await getUserUnitsInfo()
    const units = data?.payload?.unidades.map(unit => ({ name: unit.nombre, value: unit.id }))
    const everybodyItem = { name: 'Todos', value: '' }
    const userUnits = [everybodyItem, ...units]
    return dispatch(onGetUserUnitsSuccess({ userUnits }))
  } catch (error) {
    return dispatch(
      onGetUserUnitsError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}
